import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=0356f510"
import script from "./Overview.vue?vue&type=script&lang=ts"
export * from "./Overview.vue?vue&type=script&lang=ts"
import style0 from "./Overview.vue?vue&type=style&index=0&id=0356f510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports